import { DOMEvents } from '../../../utils/dom'
import { AnalyticsEvent } from '../event'
import { GlobalDataFormatter } from './global-data'
import { GtmProvider } from './gtm/default'
import { MParticleProvider } from './mparticle/events/default'
import { PermutiveProvider } from './permutive/default'

export class Default extends AnalyticsEvent {

    /**
     * Check whether this action should Skip Event Trigger or not.
     * This is used to skip the event trigger for elements with data-evt-skip-click="true" attribute.
     * Example:
     * ```html
     *    <article
     *      data-evt="click"
     *      data-evt-typ="click"
     *      data-evt-val='{"control_fields": {"mparticle": {"keys": {"click_source_type": "click_source_type"},
     *          "mp_event_type": "Navigation", "extra_keys": []}}, "click_source_type": "widget-list"}'
     *  >
     *      <a href="https://nationalpost.com/article_page">Article Title</a>
     *      <p>Summary</p>
     *      <a data-evt-skip-click="true" href="https://nationalpost.com/category_page">Category</a>
     *   </article>
     * ```
     * In the above example code, Click on the "Category" link should not trigger Analytics event.
     * But the click on the "Article Title" or "Summary" should trigger Analytics event as expected.
     * @param {string} action Event Action
     * @param {Event} event Event
     * @returns boolean
     */
    public static should_skip_event_trigger(action: string, event: Event): boolean {
        const evtTarget = event ? event.target as HTMLElement : undefined
        if (action === DOMEvents.click && evtTarget && evtTarget.getAttribute('data-evt-skip-click') === 'true') {
            // Do not trigger Analytics Event for this Click.
            return true
        } else {
            return false
        }
    }

    /**
     * Handle event
     */
    public handle(event?: Event): void {

        /**
         * Event Handler: create Attributes list and send it to vendors providers
         * @var data will be different for each event, and for each provider
         *
         */
        if(Default.should_skip_event_trigger(this.action, event)) {
            return
        }

        const dataAttrs = this.getGeneralAttributesList()

        // Get Data Values (// metaProperties data coming from page-data)
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        const data: any = {}
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr, event)
                if(attrValue !== '') {
                    data[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class Default', e)
            }
        })

        const controlFields = this.getControlFields()

        if(controlFields.mparticle) {
            const mparticle = new MParticleProvider(data, this.type, this.value, this.action, this.element)
            mparticle.setMetaProperties(this.metaProperties)
            mparticle.handle(event)
        }
        if(controlFields.gtm) {
            const gtm = new GtmProvider(data, this.type, this.value, this.action, this.element)
            gtm.setMetaProperties(this.metaProperties)
            gtm.handle()
        }
        if(controlFields.permutive) {
            const permutive = new PermutiveProvider(data, this.type, this.value, this.action, this.element)
            permutive.setMetaProperties(this.metaProperties)
            permutive.handle()
        }
    }
}
